import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Icon } from 'antd';
import Countdown from 'react-countdown-now';
import { inject, observer } from 'mobx-react';
import { getRegistered } from '../../contract/Oracles';
import NavViews from '../../stores/NavViews';
import { duration } from 'moment';


@observer(["TeamStore", "BetSlipStore", "web3Store", "CustomRouter", "AdminStore"])
class OracleEventCards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            teamOneLogo: "http://pluspng.com/img-png/nhl-png-datei-logo-nhl-svg-2000.png",
            teamTwoLogo: "http://pluspng.com/img-png/nhl-png-datei-logo-nhl-svg-2000.png",
            teamOneName: "",
            teamTwoName: "",
            timeLeftInOraclePeriod: "00",
            registered: false,

        };
    }

    async componentDidMount() {
        const {
            event_id,
            bytes32_id,
            start_time,
            duration,
            team_one,
            team_two, TeamStore } = this.props;
        console.log("teams: " + JSON.stringify(TeamStore));
        let self = this;
        getRegistered(bytes32_id).then((registered) => {
            self.setState({ registered });
        });


        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (team_one == team._id) {
                    self.setState({

                        teamOneLogo: team.logoUrl,

                        teamOneName: team.name

                    });
                }
                if (team_two == team._id) {
                    self.setState({

                        teamTwoLogo: team.logoUrl,
                        teamTwoName: team.name

                    });
                }
            });
            console.log("teams: " + JSON.stringify(TeamStore));

        }
            , 30

        );
        // let coundownTimer = <Countdown date={new Date(start_time + duration + Number(AdminStore.oraclePeriod))}>
        //     <div>NO TIME</div>
        // </Countdown>;
        // this.setState({ timeLeftInOraclePeriod: coundownTimer });
    }


    render() {
        let randNum = Math.floor(Math.random() * Math.floor(20000));
        let otherNum = 20000 - randNum;
        const DoughnutData = {
            labels: [
                this.state.teamTwoName,
                this.state.teamOneName,
            ],
            datasets: [{
                data: [randNum, otherNum],
                backgroundColor: [
                    '#5b616b',
                    '#3296f7',
                ],
                hoverBackgroundColor: [
                    '#5b616b',
                    '#3296f7',
                ],


                borderColor: [
                    'rgba(255, 255, 255, 0)',
                    'rgba(255, 255, 255, 0)',
                ],
            }]
        };
        let team_one = this.state.teamOneName;
        let team_two = this.state.teamTwoName;
        const {
            event_id,
            bytes32_id,
            start_time,
            duration,
            drawPossible,
            startTimeNumber,
            AdminStore,
        event } = this.props;

        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;

        let drawButton = "";


        return (

            <div className="main-page-cards-oracle">
                {this.state.registered ? <span style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }}><Icon type="safety" style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }} theme="outlined" /> REGISTERED</span> :
                    <span style={{ fontSize: '16px', color: '#e0e018' }}><Icon type="warning" style={{ fontSize: '16px', color: '#e0e018' }} theme="outlined" /> NOT REGISTERED</span>}
                <div className="main-page-rows-teams" onClick={() => goTo(NavViews.singleEvent, { eventID: event_id }, CustomRouter)}>
                    <div className="main-page-rows-teams-teamone">
                        <span><img src={this.state.teamOneLogo} /></span>
                        {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                        <div>{team_one}</div>
                        <div>Votes: {event.votesForTeamOne}</div>
                    </div>
                    <div className="main-page-rows-teams-vs">
                        <div style={{ marginTop: '-10px' }}>
                            <Doughnut
                                legend={null}
                                width={110}
                                options={{
                                    maintainAspectRatio: false
                                }}
                                height={55}
                                data={DoughnutData}
                            />
                        </div>
                    </div>
                    <div className="main-page-rows-teams-teamtwo">
                        <span><img src={this.state.teamTwoLogo} /></span>
                        <div>{team_two}</div>
                        <div>Votes: {event.votesForTeamTwo}</div>
                    </div>
                </div>
                <div className="main-page-cards-event-info" onClick={() => goTo(NavViews.singleEvent, { eventID: event_id }, CustomRouter)}>
                    <div>{start_time}</div>
                </div>

                {/* <div className="main-page-cards-bet-options-pick-title" onClick={() => goTo(NavViews.singleEvent, { eventID: event_id }, CustomRouter)}>
                    <span>Take Your Pick</span>
                </div>
                <div className="main-page-cards-bet-options">
                    <button onClick={() => this.addToBetSlip(1)} className="main-page-cards-options-teamone">
                        <span className="main-page-cards-bet-options-title">{team_one}</span>
                        <div className="main-page-cards-bets-amount"># OF BETS</div>
                    </button>
                    {drawButton}
                    <button onClick={() => this.addToBetSlip(2)} className="main-page-cards-options-teamtwo">
                        <span className="main-page-cards-bet-options-title">{team_two}</span>
                        <div className="main-page-cards-bets-amount"># OF BETS</div>
                    </button>
                </div> */}
                <div className="single-event-page-cards-status" onClick={() => goTo(NavViews.singleEvent, { eventID: event_id }, CustomRouter)}>
                    <div className="single-event-page-cards-status-open-expired">
                        <div style={{ padding: '14px 0px 0px 0px', color: '#f48541', textAlign: 'left', position: 'relative' }}>
                            <div className="oracle-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Oracle Period</span>

                        </div>
                        <div className="main-page-cards-status-time-remaining"><Countdown zeroPadLength={2} date={new Date(startTimeNumber + duration + Number(AdminStore.oraclePeriod)).getTime() * 1000}>
                            <span>ENDED, NO TIME</span>
                        </Countdown>
                            <span style={{ marginLeft: "5px" }}>REMAINING</span>
                        </div>
                    </div>

                </div>


            </div>

        );
    }
}


export default OracleEventCards;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/OracleEventCards.js